import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { SentryService, FrontendErrorCategory } from "@/core/sentry";

export function RouteErrorFallback() {
  const error = useRouteError();

  useEffect(() => {
    SentryService.captureException(error, {
      errorCategory: FrontendErrorCategory.RenderError,
      errorType: error instanceof Error ? error.name : "RouteError",
      level: "error",
      route: window.location.pathname,
    });
  }, [error]);

  const message = error instanceof Error ? error.message : "An unexpected error occurred";

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="max-w-md space-y-4 text-center">
        <h1 className="text-2xl font-semibold text-foreground">Something went wrong</h1>
        <p className="text-sm text-muted-foreground">{message}</p>
        <button
          onClick={() => window.location.assign("/")}
          className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          Go to home
        </button>
      </div>
    </div>
  );
}
